import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:pathMatch(.*).html',
    redirect: to => {
      return { path: to.path.replace(/\.html$/, '') }
    }
  },
  {
    path: '/',
    name: 'home',
  
    component: HomeView
  },
  {
    path: '/about',
    name: '关于我们',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/checkinguide',
    name: '入住指南',

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CheckinGuide.vue')
  },
  {
    path: '/contact',
    name: '联系我们',

    component: () => import('@/views/contact.vue')
  },
  {
    path: '/attract',
    name: '招贤纳士',

    component: () => import('@/views/attract.vue')
  },
  {
    path: '/event',
    name: '新闻中心',

    component: () => import('@/views/event.vue')
  },
  {
    path: '/event-details/:id',
    name: '新闻详情',

    component: () => import('@/views/EventDetails.vue')
  },

  {
    path: "/CheckinGuide-details/:id",
    name: "articleDetails", // 修改路由名称
    component: () => import('@/views/ArticleDetails.vue')  // 动态导入文章详情组件
  },
  {
    path: '/companyProfile',
    name: '公司简介',

    component: () => import('../views/CompanyProfile.vue')
  },
  {
    path: '/companyCulture',
    name: '企业文化',

    component: () => import('../views/CompanyCulture.vue')
  },
  {
    path: '/blog',
    name: '医养结合',

    component: () => import('../views/MedicalMaintenance.vue')
  },
  {
    path: '/companyHonor',
    name: '企业荣誉',

    component: () => import('../views/CompanyHonor.vue')
  },
  {
    path: '/productshow',
    name: '产品展示',

    component: () => import('../views/ProductShow.vue')
  },
  {
    path: '/rcm',
    name: 'rcm',

    component: () => import('../views/RcmPage.vue')
  },
  { path: '/:pathMatch(.*)*', redirect: '/' }

]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
